import React from 'react';
import ReactSelectAsync from '../../selects/react-select-async';
import '../fieldstyle.css'

export default class FieldGetSelectAsync extends React.Component{
  constructor(props){
    super(props);
    this.onBlur = this.onBlur.bind(this);
  } 
  
  onBlur(){
    this.props.input.onBlur(this.props.input.value);

    if (this.props.funcAdicional_OnBlur){
      this.props.funcAdicional_OnBlur()
    }
  }

  render(){
    return(
      <div className='grupo-form'>
        <label className='label-control'>{this.props.label}</label>
        <div>
          < ReactSelectAsync {... this.props.input} value={this.props.input.value} func_onChange={(value) => this.props.input.onChange(value)} func_onBlur={this.onBlur} func_loadOptions={this.props.loadOptions} 
          />
        </div>
      </div>
    );
  }
}